export default function getSocieteDefautUtilisateur(societes, user) {
  if (!societes || societes.length === 0) return null;
  const societeId = user && user.agence ? user.agence.societeId : null;
  return societes.some(s => s.id === societeId) ? societeId : societes[0].id;
}
